import { FC } from 'react';
import { Text, Paper, Loader } from '@mantine/core';

import classes from './CallStat.module.scss';

interface CallStatProps {
  stat: {
    label: string;
    value: number | string;
    labelDescriptor?: string;
    valueDescriptor?: string;
  };
  isLoading?: boolean;
}

const CallStat: FC<CallStatProps> = ({ stat, isLoading }) => {
  return (
    <Paper
      withBorder
      py="3rem"
      px="md"
      h="100%"
      radius="md"
      className={classes.paper}
    >
      <Text className={classes.label} c="dimmed">
        {stat.label}
        {stat.labelDescriptor && (
          <Text className={classes.labelDescriptor} span size="xs" ml={4}>
            {stat.labelDescriptor}
          </Text>
        )}
      </Text>
      {isLoading ? (
        <Loader
          size="md"
          type="dots"
          h={{ base: 37.2, md: 45 }}
          mt={6}
          color="var(--mantine-color-gray-3)"
        />
      ) : (
        <Text className={classes.value} fw={600} mt={6}>
          {stat.value}
          {stat.valueDescriptor && (
            <Text className={classes.valueDescriptor} span size="xs" ml={4}>
              ({stat.valueDescriptor})
            </Text>
          )}
        </Text>
      )}
    </Paper>
  );
};

export default CallStat;
